import { Flex } from "common/components/flex/flex";
import { StatusTag } from "common/components/statusTag/statusTag";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";
import { ExclamationCircleIcon } from "features/dashboard/components/icons/ExclamationCircle";
import { ExclamationTriangleIcon } from "features/dashboard/components/icons/ExclamationTriangle";
import {toShortUSFormat} from "../../../../../utilities/dateUtility";

export const getPipelineCandidateRowId = (params) => params.data.id;

const daysInStatusValueGetter = (params) => {
  const daysInStatus = params.data?.daysInStatus;

  if (daysInStatus === undefined || daysInStatus === null) return null;

  const { days } = daysInStatus;
  if (days === undefined || days === null || days < 0) return null;

  return days;
};

const formatDaysInStatus = (days) => {
  if (days === null) return K.NullPlaceholder;
  return `${days} days`;
};

const getDaysInStatusAlertLevelIcon = (warning) => {
  if (warning === K.DaysInStatusAlertLevel.warning) {
    return <ExclamationCircleIcon style={{ marginLeft: 4, fontSize: 16 }} />;
  }

  if (warning === K.DaysInStatusAlertLevel.critical) {
    return <ExclamationTriangleIcon style={{ marginLeft: 4, fontSize: 16 }} />;
  }

  return null;
};

const formatDaysInStatusTooltip = (dateField, date) => {
  const label = K.Candidate.DateFields[dateField]?.label;
  const value = date ? toShortUSFormat(date) : K.NullPlaceholder;

  return `${label}: ${value}`;
};

const daysInStatusTooltipValueGetter = (params) => {
  const { dateField, date } = params.data?.daysInStatus ?? {};

  return formatDaysInStatusTooltip(dateField, date);
};

const daysInStatusRenderer = (params) => {
  const days = params.value;
  if (days === null) return formatDaysInStatus(days);

  const level =
    params.data?.daysInStatus?.alertLevel ?? K.DaysInStatusAlertLevel.none;
  const color = K.DaysInStatusAlertLevelColors[level];
  const icon = getDaysInStatusAlertLevelIcon(level);

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      style={{ width: "100%", color: color || "inherit" }}
    >
      {icon}
      <span>{formatDaysInStatus(days)}</span>
    </Flex>
  );
};

export const PipelineCandidatesColumns = [
  { ...DefaultColumnOptions.Id, field: "candidate.id" },
  {
    headerName: "First Name",
    field: "candidate.firstName",
    tooltipField: "candidate.firstName",
  },
  {
    headerName: "Last Name",
    field: "candidate.lastName",
    tooltipField: "candidate.lastName",
  },
  {
    headerName: "Status",
    field: "status.name",
    tooltipField: "status.name",
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag status={params.value} />
      </Flex>
    ),
  },
  {
    headerName: "Sub Status",
    field: "subStatus.name",
    tooltipField: "subStatus.name",
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag
          status={params.value}
          parentStatus={params.data?.status?.name}
        />
      </Flex>
    ),
  },
  {
    headerName: "ATS ID",
    field: "atsId",
    tooltipField: "atsId",
  },
  {
    headerName: "Job ID",
    field: "job.id",
  },
  {
    headerName: "Job Title",
    field: "job.title",
    tooltipField: "job.title",
  },
  {
    headerName: "Job Department",
    field: "job.jobDepartment.name",
    headerTooltip: "Job Department",
    tooltipField: "job.jobDepartment.name",
  },
  {
    headerName: "Days in Status",
    field: "daysInStatus",
    headerTooltip: "Days In Status",
    sort: "desc",
    valueGetter: daysInStatusValueGetter,
    cellRenderer: daysInStatusRenderer,
    tooltipValueGetter: daysInStatusTooltipValueGetter,
  },
];
